import { NgModule, provideBrowserGlobalErrorListeners } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './interceptors/auth-interceptor';

import { ToastNoAnimationModule } from 'ngx-toastr';

import { AppRoutingModule } from './app-routing-module';
import { App } from './app';
import { AdminLayout } from './layouts/admin-layout/admin-layout';
import { Dashboard } from './pages/dashboard/dashboard';
import { Login } from './pages/auth/login/login';
import { Organizations } from './pages/organizations/organizations';
import { OrganizationDetails } from './pages/organization-details/organization-details';
import { ValidationLogs } from './pages/validation-logs/validation-logs';
import { AuditLogs } from './pages/audit-logs/audit-logs';
import { AdminUsers } from './pages/admin-users/admin-users';
import { Settings } from './pages/settings/settings';
import { PasswordResetRequests } from './pages/password-reset-requests/password-reset-requests';
import { Profile } from './pages/profile/profile';

@NgModule({
  declarations: [
    App,
    AdminLayout,
    Dashboard,
    Login,
    Organizations,
    OrganizationDetails,
    ValidationLogs,
    AuditLogs,
    AdminUsers,
    Settings,
    PasswordResetRequests,
    Profile,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ToastNoAnimationModule.forRoot({
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      timeOut: 4000,
      closeButton: true,
      progressBar: true,
    }),
  ],
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withInterceptors([authInterceptor])),
  ],
  bootstrap: [App],
})
export class AppModule {}
